import { action, atom } from '@reatom/framework'

import { AsyncStateN } from '@blade/std-lib'
import { delugeIdAtom, getCachedDelugeId } from '@root/entities/auth/atoms'
import {
  initializeSecureStorageStateAction,
  storageSessionStateAtom,
} from '@root/features/secure-storage/atoms'
import { ApiError } from '@root/shared/api'

import { InitializationState } from '../../model'
import { initializeUserAction, meStateAtom } from '../common/reatom-me'

export const initializationStateAtom = atom<InitializationState.State>(
  new InitializationState.Initial(),
  'initializationStateAtom',
)
export const isInitializationReadyAtom = atom((ctx) => {
  const state = ctx.spy(initializationStateAtom)
  return state instanceof InitializationState.Ready
}, 'isInitializationReadyAtom')

export const isInitializationReadyOrWebsiteAtom = atom((ctx) => {
  const state = ctx.spy(initializationStateAtom)
  return (
    state instanceof InitializationState.Ready ||
    state instanceof InitializationState.Website
  )
}, 'isInitializationReadyOrWebsiteAtom')

export const isWebsiteAtom = atom((ctx) => {
  const state = ctx.spy(initializationStateAtom)
  return state instanceof InitializationState.Website
}, 'isWebsiteAtom')

export const loginWithUsernameClickedAction = action((ctx) => {
  initializationStateAtom(
    ctx,
    new InitializationState.Login({
      loginMethod: { type: 'username' },
    }),
  )
}, 'loginWithUsernameClickedAction')

export const backClickedAction = action((ctx) => {
  const initializationState = ctx.get(initializationStateAtom)
  if (initializationState instanceof InitializationState.Otp) {
    initializationStateAtom(ctx, new InitializationState.Initial())
    return
  }

  if (initializationState instanceof InitializationState.Login) {
    initializationStateAtom(ctx, new InitializationState.Initial())
    return
  }

  if (initializationState instanceof InitializationState.Register) {
    initializationStateAtom(ctx, new InitializationState.Initial())
    return
  }
}, 'backClickedAction')

export const retryInitializationAction = action((ctx) => {
  const meRequestState = ctx.get(meStateAtom)
  if (
    AsyncStateN.isError(meRequestState) &&
    !ApiError.isUnauthorizedOrExpired(meRequestState.error)
  ) {
    initializeUserAction(ctx)
  }

  const sessionState = ctx.get(storageSessionStateAtom)
  const cachedDelugeId = ctx.get(delugeIdAtom) ?? getCachedDelugeId()
  if (AsyncStateN.isError(sessionState) && cachedDelugeId) {
    initializeSecureStorageStateAction(ctx, cachedDelugeId)
  }
}, 'retryInitializationAction')
